// extracted by mini-css-extract-plugin
export var bottombar = "AnimationWrapper-module--bottombar--1cd83";
export var container = "AnimationWrapper-module--container--a138f";
export var content = "AnimationWrapper-module--content--bc490";
export var topbar = "AnimationWrapper-module--topbar--e8b12";
export var wrapper = "AnimationWrapper-module--wrapper--bfd46";